import { Modal } from "react-bootstrap";

const NoReplyMailModal = ({ showisMailVisible, setShowisMailVisible }) => {
    return (
        <>
            <Modal
                show={showisMailVisible}
                onHide={() => setShowisMailVisible(false)}
                size="md"
                centered
                backdrop="static"
                className="rounded-3 shadow-lg"
            >
                <Modal.Header
                    closeButton
                    className="border-0 pb-0 pt-3 px-4 mb-2 mt-1"
                    style={{ position: "relative" }}
                >
                </Modal.Header>

                <Modal.Body className="px-4 py-3 text-center">
                    <p className="fs-6 text-gray-700 mb-4 leading-relaxed">
                       First, drag the email to a board, then create a task, and finally add your reply.
                    </p>
                    <div className="d-flex justify-content-center">
                        <button
                            className="btn btn-primary px-4 py-2 rounded-pill fw-semibold"
                            onClick={() => setShowisMailVisible(false)}
                        >
                            Got It
                        </button>
                    </div>
                </Modal.Body>
            </Modal>

        </>
    )

}

export default NoReplyMailModal;